<template>
	<span class="info-button" :style="iconSize">
		<i
			class="icon"
			:class="iconClassName"
			@click="handleVisible"
			data-test="icon-info-btn"
			ref="popoverPositionRef"
		></i>

		<Popover
			v-if="visible"
			:display="true"
			trackedRefName="popoverPositionRef"
			:position="position"
			:text="text"
			:subText="subText"
			data-test="popOver"
		></Popover>
	</span>
</template>

<script>
import Popover from '@/components/notifications/popover/popover';

// mixins
import DocumentClick from '@/mixins/document-click';

export default {
	name: 'IconInfo',
	components: {
		Popover
	},
	mixins: [DocumentClick('hidePopover')],
	props: {
		fontSize: {
			type: String,
			default: '12px'
		},
		iconClassName: {
			type: String,
			default: 'icon-info-solid'
		},
		position: {
			type: String,
			default: 'right',
			validator: function validator(value) {
				return ['top', 'bottom', 'right', 'left'].indexOf(value) > -1;
			}
		},
		text: {
			type: String,
			require: true
		},
		subText: {
			type: String,
			default: ''
		},
		timeout: {
			type: Number,
			default: -1
		}
	},
	data() {
		return {
			visible: false,
			timer: null
		};
	},
	computed: {
		iconSize() {
			if (typeof this.fontSize === 'number') {
				return {
					fontSize: `${this.fontSize}px`
				};
			} else {
				return {
					fontSize: this.fontSize
				};
			}
		}
	},
	methods: {
		handleVisible() {
			this.visible = !this.visible;

			if (this.visible && this.timeout > 0) {
				this.setTimeout();
			}

			if (!this.visible && this.timeout > 0 && (this.timer ?? '')) {
				clearTimeout(this.timer);
			}
		},
		hidePopover() {
			this.freeTimeout();
			this.visible = false;
		},
		setTimeout() {
			this.freeTimeout();
			this.timer = setTimeout(() => {
				this.hidePopover();
			}, this.timeout);
		},
		freeTimeout() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
		}
	}
};
</script>

<style lang="scss">
.info-button {
	display: flex;
	align-items: center;

	.icon {
		cursor: pointer;
		color: $neutral-1;
	}
}
</style>
